import request from '@/utils/request'
import { sift_query_list } from '@/utils/sift';
const ls = process.env.NODE_ENV === 'development' ? '/larkswitch' : '';
// const ls = '';

/************* 小程序卡片 *******************/

// 小程序卡片刷新
export function refreshMiniData(brand,appid) {
    return request({
        url: `/ocs-kdb/miniProgram/${brand}/excute`,
        method: 'get',
		params: {appid}
    })
}
// 获取列表
export function getMiniData(query) {
    return request({
        url: `/ocs-kdb/miniProgram/list/json`,
        method: 'get',
		params: sift_query_list(query)
    })
}

/* **************技能组 **********************/
// 技能组获取列表
export function getSystemSkillGroup(data) {
	return request({
	    url: `/livechat/skillGroup/list`,
	    method: 'post',
		data: data
	})
}
// 技能组编辑以及新增
export function postSystemSkillGroup(url,data) {
	return request({
	    url: `/livechat/skillGroup/${url}`,
	    method: 'post',
		data: data
	})
}
//获取技能组下可绑定人员
export function getSystmeSkillGroupUsers(query){
	return request({
		url:'/livechat/skillGroup/list/user',
		method:'get',
		params: sift_query_list(query)
	})
}
//获取所有人员
export function getSystemSkillGroupAllUsers(data){
	return request({
		url:'/ocs-auth/user/manage/basic/list',
		method:'post',
		data: data
	})
}
// 绑定员工到技能组
export function setSystemSkillGroupToBind(data){
	return request({
		url:'/livechat/skillGroup/associate/user',
		method:'post',
		data: data
	})
}
/************************* IM路由设置 *********************/
//获取子品牌下的路由设置
export function getImServiceRouterList(brand){
	return request({
		url:`/livechat/router/get/${brand}`,
		method:'get'
	})
}
//更新子品牌下路由设置
export function updateImServiceRouterItem(data){
	return request({
		url:`/livechat/router/update`,
		method:'post',
		data:data
	})
}


/* ****************聊天功能设置************************ */
//获取列表
export function postSystemChatList(data) {
	return request({
	    url: `/livechat/skillGroup/list`,
	    method: 'post',
		data: data
	})
}
//获取满意度调查
export function getSystemSatisfaction(skillGroup) {
    return request({
        url: `/livechat/chatSetting/get/auth/${skillGroup}`,
        method: 'get',
    })
}
// 满意度配置保存
export function saveSystemSatisfaction(skillGroup,data) {
	return request({
	    url: `/livechat/chatSetting/update/auth/${skillGroup}`,
	    method: 'post',
		data: data
	})
}

/* ******************应用到其他技能组***************************** */

export function applySystemSkillGroup(url,data) {
	return request({
	    url: url,
	    method: 'post',
		data: data
	})
}

/* ******************开闭线***************************** */
//获取话术列表msgId
export function getSystemEffectMsgids(brand) {
    return request({
        url: `/livechat/speechcraft/list/holiday/msg/v1`,
        method: 'get',
		params:{brand}
    })
}
//获取开闭线列表
export function getSystemEffectLists(query) {
    return request({
        url: `/livechat/workday/list`,
        method: 'get',
		params: sift_query_list(query)
    })
}
// 删除开闭线某条时间记录
export function deleteSystemEffectListItem(skillGroupId) {
    return request({
        url: `/livechat/workday/delete/${skillGroupId}`,
        method: 'post',
    })
}
// 更新、新增开闭线时间策略
export function updateSystemEffectListItem(data) {
	return request({
	    url: `/livechat/workday/saveOrUpdate`,
	    method: 'post',
		data: data
	})
}

/* ******************快捷话术***************************** */
//获取快捷话术树状列表
export function getSystemFastWordsLists(query) {
    return request({
        url: `/ocs-kdb/manager/index/listChildNode`,
        method: 'get',
		params: sift_query_list(query)
    })
}
// 搜索列表数据
export function searchSystemFastWordsLists(url,data) {
	return request({
	    url: url,
	    method: 'post',
	})
}
//删除快捷某条话术
export function deleteSystemFastWordsListItem(id) {
    return request({
        url: `/ocs-kdb/manager/delete`,
        method: 'post',
		data:{id}
    })
}
// 更新、新增快捷话术
export function updateSystemFastWordsListItem(data) {
	return request({
	    url: `/ocs-kdb/manager/saveOrUpdate`,
	    method: 'post',
		data: data
	})
}
// 快捷话术上传文件
export function uploadSystemFastWordsFile(data) {
	return request({
	    url: `/ocs-kdb/manager/file/upload`,
	    method: 'post',
		data: data
	})
}
// 下载模板
export function downloadSystemFastWordsModel(){
	return request({
		url:'/ocs-kdb/import/download/majorel/overimportTemplete',
		method:'get'
	})
}
//导入文件
export function importSystemFastWordsFile(brand,data){
	return request({
		url:`/ocs-kdb/import/upload/${brand}/overimportTemplete`,
		method:'post',
		data:data
	})
}

/* ******************话术类型***************************** */
//获取列表
export function getSystemWordsLists(data) {
	return request({
	    url: `/livechat/speechcraft/list/holiday/msg`,
	    method: 'post',
		data: data
	})
}
// 获取参数列表
export function getSystemWordsParams() {
    return request({
        url: `/livechat/speechcraft/params/list`,
        method: 'get',
    })
}
// 获取某条列表详情
export function getSystemWordsListsItem(id) {
    return request({
        url: `/livechat/speechcraft/get/${id}`,
        method: 'get',
    })
}
// 保存数据
export function saveSystemWordsListsItem(data) {
	return request({
	    url: `/livechat/speechcraft/saveOrUpdate`,
	    method: 'post',
		data: data
	})
}
// 删除某条记录
export function deleteSystemWordsListsItem(data){
	return request({
		url:`/livechat/speechcraft/deleteBatch`,
		method:'post',
		data:data
	})
}
// 话术类型下拉框数据
export function getSystemWordsOptions() {
    return request({
        url: `/livechat/speechcraft/params/msgtype/list`,
        method: 'get',
    })
}

/* ******************微信接入***************************** */
//二维码绑定
export function getWechatSystemAuthUrl(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/getPreAuthUrl`,
		method:'post',
		data:data
	})
}
//二维码绑定首次无id生成
export function getWechatSystemAuthV2Url(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/v2/getPreAuthUrl`,
		method:'post',
		data:data
	})
}
// 手动绑定
export function getWechatSystemAuthDev(data){
	return request({
		url:`/ocs-wechat-platform/wechat/dev/appid/save`,
		method:'post',
		data:data
	})
}
//获取绑定列表
export function getWechatSystemLists(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/appid/select`,
		method:'post',
		data:data
	})
}
// 添加公众号、小程序
export function wechatSystemAdd(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/appid/save`,
		method:'post',
		data:data
	})
}
//编辑公众号，小程序
export function wechatSystemEdit(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/appid/update`,
		method:'post',
		data:data
	})
}
//添加自动生成id
export function createWechatSyatemId(){
	return request({
		url:'/id-generator/generator/id',
		method:'get'
	})
}
//关键词获取根据ID查询规则
export function getWechatSystemkeywordsRules(data){
	return request({
		url:`/ocs-wechat-platform/keyword/selectRules`,
		method:'post',
		data:data
	})
}

//规则新建-关键字
export function addWechatSystemkeyword(data){
	return request({
		url:`/ocs-wechat-platform/keyword/insertRules`,
		method:'post',
		data:data
	})
}
//规则编辑-关键字
export function editWechatSystemkeyword(data){
	return request({
		url:`/ocs-wechat-platform/keyword/updateRules`,
		method:'post',
		data:data
	})
}
//规则删除-关键字
export function deleteWechatSystemkeyword(data){
	return request({
		url:`/ocs-wechat-platform/keyword/deleteRules`,
		method:'post',
		data:data
	})
}

//收到消息回复-列表查询
export function getWechatSystemNoKeywords(data){
	return request({
		url:`/ocs-wechat-platform/autoMessage/selectRules`,
		method:'post',
		data:data
	})
}
//收到消息回复 - 规则新建
export function addWechatSystemNoKeywords(data){
	return request({
		url:`/ocs-wechat-platform/autoMessage/insertRules`,
		method:'post',
		data:data
	})
}
//收到消息回复 - 规则编辑
export function editWechatSystemNoKeywords(data){
	return request({
		url:`/ocs-wechat-platform/autoMessage/updateRules`,
		method:'post',
		data:data
	})
}
//收到消息回复 - 规则删除
export function deleteWechatSystemNoKeywords(data){
	return request({
		url:`/ocs-wechat-platform/autoMessage/deleteRules`,
		method:'post',
		data:data
	})
}
//事件配置 - 查询列表
export function getWechatSystemEvent(data){
	return request({
		url:`/ocs-wechat-platform/event/selectRules`,
		method:'post',
		data:data
	})
}
//事件配置 - 新增
export function addWechatSystemEvent(data){
	return request({
		url:`/ocs-wechat-platform/event/insertRules`,
		method:'post',
		data:data
	})
}
//事件配置 - 编辑
export function editWechatSystemEvent(data){
	return request({
		url:`/ocs-wechat-platform/event/updateRules`,
		method:'post',
		data:data
	})
}

//微信基础配置 - 技能组列表
export function getWechatSystemSkillGroup(data){
	return request({
		url:`/livechat/skillGroup/list/${data.brand}/${data.appid}`,
		method:'get',
	})
}


//查看绑定url/token 开发者管理
export function getWechatTokenUrl(appid){
	return request({
		url:`/ocs-wechat-platform/wechat/dev/appid/get/${appid}`,
		method:'get',
	})
}

//获取开放着平台详情 
export function getWechatSystemOpenTypePlatform(appid){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/appid/selectdetail/${appid}`,
		method:'post',
	})
}

//基础设置更新技能组
export function updateWechatSystemBasic(data){
	return request({
		url:`/ocs-wechat-platform/wechatPlatform/grant/livechat/update`,
		method:'post',
		data:data
	})
}

// ! 获取渠道列表
export function apiPostProjectChannelPageList(data){
	return request({
		url: `/ocs-project/project/channel/pageList.json`,
		method: 'post',
		data: data,
		contentType: 'formData'
	})
}

// ! 添加获取渠道
export function apiPostProjectChannelAdd(data){
	return request({
		url: `/ocs-project/project/channel/add.json`,
		method: 'post',
		data: data,
		contentType: 'formData'
	})
}

// ! 修改获取渠道
export function apiPostProjectChannelEdit(data){
	return request({
		url: `/ocs-project/project/channel/edit.json`,
		method: 'post',
		data: data,
		contentType: 'formData'
	})
}

// ! 删除获取渠道
export function apiPostProjectChannelDelete(id){
	return request({
		url: `/ocs-project/project/channel/delete/${id}`,
		method: 'post'
	})
}

// ! 品牌更新larkurl
export function apiPostAuthBrandManageField(data){
	return request({
		url: `/ocs-auth/brand/manage/update/field`,
		method: 'post',
		data: data
	})
}
/* 京东小程序接入 */

//查询已绑定列表
export function apiGetJdBindLists(data){
	return request({
		url: `/ocs-jd-platform/jdPlatform/appid/list`,
		method: 'post',
		data:data
	})
}

//解绑
export function apiUnbindJdItem(data){
	return request({
		url: `/ocs-jd-platform/jdPlatform/appid/delete`,
		method: 'post',
		data:data
	})
}

//新增绑定
export function apiAddBindJdItem(data){
	return request({
		url: `/ocs-jd-platform/jdPlatform/appid/save`,
		method: 'post',
		data:data
	})
}

//设置
export function apiUpdateBindJdItem(data){
	return request({
		url: `/ocs-jd-platform/jdPlatform/appid/update`,
		method: 'post',
		data:data
	})
}

//接入授权人工
export function apiAcceptAuthForSystem(appid,data){
	return request({
		url: `/livechat/grant/transferurl/${appid}`,
		method: 'post',
		data:data
	})
}

//获取已授权人工
export function apiGetAcceptAuthForSystem(appid){
	return request({
		url: `/livechat/grant/get/${appid}`,
		method: 'get',
	})
}

/* *******微博接入 ********/
// 获取已绑定微博列表
export function getWeiboListForSystem(){
	return request({
		url: `/ocs-weibo-platform/fans/weibofansaccount/getLists`,
		method: 'post',
	})
}

// 微博绑定第一步新建微博
export function bindWeiboFirstForSystem(data){
	return request({
		url: `/ocs-weibo-platform/fans/weibofansaccount/save`,
		method: 'post',
		data:data
	})
}
// 获取appKey
export function getWeiboAppkeyForSystem(){
	return request({
		url: `/ocs-weibo-platform/fans/getAppkey`,
		method: 'get',
	})
}
// 获取URL
export function getWeiboUrlForSystem(){
	return request({
		url: `/ocs-weibo-platform/fans/getCallbackUrl`,
		method: 'get',
	})
}
// 更新微博设置，基础设置
export function updateWeiboConfigsForSystem(data){
	return request({
		url: `/ocs-weibo-platform/fans/weibofansaccount/update`,
		method: 'post',
		data:data
	})
}
// 解绑
export function unbindWeiboForSystem(data){
	return request({
		url: `/ocs-weibo-platform/fans/weibofansaccount/unbind`,
		method: 'post',
		data:data,
		contentType: 'formData'
	})
}
// 高级设置 关键字列表获取
export function getWeiboKeywordListForSystem(data){
	return request({
		url: `/ocs-weibo-platform/keyword/selectRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 添加关键字
export function addWeiboKeywordForSystem(data){
	return request({
		url: `/ocs-weibo-platform/keyword/insertRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 更新关键字
export function updateWeiboKeywordForSystem(data){
	return request({
		url: `/ocs-weibo-platform/keyword/updateRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 删除关键字
export function deleteWeiboKeywordForSystem(data){
	return request({
		url: `/ocs-weibo-platform/keyword/deleteRules`,
		method: 'post',
		data:data,
	})
}

// 高级设置 查询消息回复
export function getWeiboMessageListForSystem(data){
	return request({
		url: `/ocs-weibo-platform/autoMessage/selectRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 新建消息回复
export function addWeiboMessageForSystem(data){
	return request({
		url: `/ocs-weibo-platform/autoMessage/insertRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 更新消息回复
export function updateWeiboMessageForSystem(data){
	return request({
		url: `/ocs-weibo-platform/autoMessage/updateRules`,
		method: 'post',
		data:data,
	})
}
// 高级设置 删除消息回复
export function deleteWeiboMessageForSystem(data){
	return request({
		url: `/ocs-weibo-platform/autoMessage/deleteRules`,
		method: 'post',
		data:data,
	})
}

/* 电话模块 */

/* 开闭线 */
//获取列表
export function apiGetTelLineMangerForSystem(data){
	return request({
		url: `${ls}/day/manage/querySkillGroupDayCount.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

//删除电话技能组时间配置数据
export function apiDeleteTelSkillgroupForSystem(data){
	return request({
		url: `${ls}/day/manage/skillGroup/delete.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

//获取电话技能组
export function apiGetTelSkillgroupForSystem(data){
	return request({
		url: `${ls}/project/manage/queue/selectList.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 查询工作日列表
export function apiGetWorkdayListForSystem(data){
	return request({
		url: `${ls}/day/manage/queryWorkdayList.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}
// Aux状态管理
export function apiPostLarkswitchAuxConfigList(data){
	return request({
		url: `${ls}/project/auxConfig/list.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

//添加工作日
export function apiAddWorkdayListForSystem(data){
	return request({
		url: `${ls}/day/manage/workday/add.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}
// Aux状态管理 - 新增
export function apiPostLarkswitchAuxConfigCreate(data){
	return request({
		url: `${ls}/project/auxConfig/add.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

//修改工作日
export function apiUpdateWorkdayListForSystem(data){
	return request({
		url: `${ls}/day/manage/workday/update.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}
// Aux状态管理 - 修改
export function apiPostLarkswitchAuxConfigEdit(data){
	return request({
		url: `${ls}/project/auxConfig/edit.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

//删除工作日
export function apiDeleteWorkdayListForSystem(data){
	return request({
		url: `${ls}/day/manage/workday/delete.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 查询节假日、特殊工作日列表 holidayType【1：特殊工作日 0 节假日】
export function apiGetHolidayListForSystem(data){
	return request({
		url: `${ls}/day/manage/queryHolidayList.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}
//添加节假日、特殊工作日
export function apiAddHolidayListForSystem(data){
	return request({
		url: `${ls}/day/manage/holiday/add.json`,
		method: 'post',
		data:data,
		baseUrlType: 'larkSwitch'
	})
}
// Aux状态管理 - 排序
export function apiPostLarkswitchAuxConfigDragOrder(data){
	return request({
		url: `${ls}/project/auxConfig/adjustDragOrder`,
		method: 'post',
		data:data,
		baseUrlType: 'larkSwitch'
	})
}
//修改节假日、特殊工作日
export function apiUpdateHolidayListForSystem(data){
	return request({
		url: `${ls}/day/manage/holiday/update.json`,
		method: 'post',
		data:data,
		baseUrlType: 'larkSwitch'
	})
}
//删除节假日、特殊工作日
export function apiDeleteHolidayListForSystem(data){
	return request({
		url: `${ls}/day/manage/delHoliday.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 电话技能组列表
export function apiPostLarkswitchManageQueueList(data){
	return request({
		url: `${ls}/project/manage/queue/list.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 复制技能组
export function apiCopyTelSkillgroupForSystem(data){
	return request({
		url: `${ls}/day/manage/skillGroup/copy.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}
// 查询工号列表
export function apiPostLarkswitchAgentList(data){
	return request({
		url: `${ls}/project/manage/agent/list.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 技能组下账号
export function apiPostLarkswitchManageQueueAgentList(data){
	return request({
		url: `${ls}/project/manage/queue/agentList.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 技能组添加账号
export function apiAddLarkswitchManageQueueAgentList(data){
	return request({
		url: `${ls}/project/manage/tier/add/account.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 技能组删除账号
export function apiAddLarkswitchManageQueueAgentDelete(data){
	return request({
		url: `${ls}/project/manage/tier/delete/account.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}

// 获取有工号的坐席列表
export function apiPostUserAgentCodeList(data){
	return request({
		url: `/ocs-auth/user/manage/agentCode/list`,
		method: 'post',
		data:data
	})
}

// 获取有工号的坐席列表
export function apiPostUpdateAgentLevel(data){
	return request({
		url: `${ls}/project/manage/updateAgentLevel.json`,
		method: 'post',
		data:data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	})
}